import app from 'flarum/forum/app';
import avatar from 'flarum/common/helpers/avatar';
import Button from 'flarum/common/components/Button';
import username from 'flarum/common/helpers/username';
import UserPage from 'flarum/forum/components/UserPage';
import Placeholder from 'flarum/common/components/Placeholder';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Select from 'flarum/common/components/Select';
export default class ProfilePage extends UserPage {
  oninit(vdom) {
    // Standard UserPage expects a username in the route.
    // Since we are using a custom route without it, we manually set the user.
    this.user = app.session.user;

    // We don't call super.oninit(vdom) because it would try to load a user from the route.
    // Instead, we manually initialize what's needed.
    this.loading = false;
    this.loadingIgnored = true;
    this.ignoredUsers = [];
    if (this.user) {
      this.show(this.user);
    } else {
      // If for some reason session user is not available (e.g. guest, though link is hidden)
      app.history.back();
    }
  }
  loadUser(username) {
    // Override to prevent UserPage from trying to load a user from the API
  }
  show(user) {
    // super.show sets some internal state and titles
    super.show(user);
    this.loadIgnoredUsers();
  }
  loadIgnoredUsers() {
    this.loadingIgnored = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/bizkaitarra/ignored-users'
    }).then(payload => {
      const users = (payload.data || []).map(userData => {
        return app.store.pushObject(userData);
      });
      this.ignoredUsers = users;
      this.loadingIgnored = false;
      m.redraw();
    }).catch(() => {
      this.loadingIgnored = false;
      m.redraw();
    });
  }
  content() {
    return m("div", {
      className: "IgnoredUsersListContainer"
    }, m("h2", {
      className: "IgnoredUsersPage-title"
    }, m("i", {
      className: "fas fa-user-slash"
    }), ' ', app.translator.trans('bizkaitarra-ignore-users.forum.profile_link')), this.loadingIgnored ? m(LoadingIndicator, null) : this.ignoredUsers.length === 0 ? m("div", {
      className: "DiscussionList"
    }, m(Placeholder, {
      text: app.translator.trans('bizkaitarra-ignore-users.forum.profile_page.no_ignored')
    })) : m("div", {
      className: "IgnoredUsersList"
    }, m("table", {
      className: "NotificationGrid"
    }, m("tbody", null, this.ignoredUsers.map((user, i) => {
      const unignore = () => {
        if (confirm(app.translator.trans('bizkaitarra-ignore-users.forum.user_controls.unignore_confirmation'))) {
          user.save({
            ignored: false
          }).then(() => {
            this.ignoredUsers.splice(i, 1);
            m.redraw();
          });
        }
      };
      return m("tr", {
        key: user.id()
      }, m("td", null, m("a", {
        href: app.route.user(user),
        oncreate: m.route.handle
      }, m("div", {
        className: "IgnoredUser-info"
      }, avatar(user, {
        className: 'ignorePage-avatar'
      }), m("span", {
        className: "IgnoredUser-name"
      }, username(user))))), m("td", {
        className: "ignorePage-level"
      }, Select.component({
        options: {
          0: app.translator.trans('bizkaitarra-ignore-users.forum.ignore_modal.level_partial'),
          1: app.translator.trans('bizkaitarra-ignore-users.forum.ignore_modal.level_total')
        },
        value: user.ignoreLevel() || 0,
        onchange: value => {
          user.save({
            ignoreLevel: parseInt(value)
          }).then(() => {
            m.redraw();
          });
        }
      })), m("td", {
        className: "ignorePage-button"
      }, Button.component({
        icon: 'fas fa-user-plus',
        type: 'button',
        className: 'Button Button--warning',
        onclick: unignore
      }, app.translator.trans('bizkaitarra-ignore-users.forum.user_controls.unignore_button'))));
    })))));
  }
}
flarum.reg.add('bizkaitarra-ignore-users', 'forum/components/ProfilePage', ProfilePage);